import React from "react";
import { useNavigate } from "react-router-dom";

export default function CheckoutHeader({ title }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/order-online", { replace: true });
  };

  return (
    <div className="mb-8 flex flex-wrap items-center justify-between gap-4 sm:mb-10">
      <div className="min-w-0">
        <h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
          {title}
        </h1>
      </div>

      <button
        type="button"
        onClick={handleBack}
        className="inline-flex shrink-0 items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2.5 text-sm font-medium text-white backdrop-blur-md transition hover:border-orange-500/50 hover:bg-orange-500 hover:text-black active:scale-95"
      >
        <span className="material-icons text-[18px] leading-none">
          arrow_back
        </span>
        Back
      </button>
    </div>
  );
}